// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1fVrx","bigColWidth":"Table_bigColWidth__1uilW","biggerColWidth":"Table_biggerColWidth__2ZQQH","row":"Table_row__2mQRh","col":"Table_col__3C5VF"};